import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const ALL_LAYOUTS = ['vertical-centered-single', 'vertical-centered-double'];

// Componente estilizado para o contêiner do card
const CardContainer = styled.div`
  padding-inline: 2rem;
  padding-block: 0.5rem;
  border-radius: ${({ borderRadius }) => `calc(${borderRadius}/2)`};
  border: 0.5px solid;
  font-weight: 600;
  color: white;
  background-color: ${({ backgroundColor, secondaryColor }) =>
    backgroundColor ?? secondaryColor};
`;

// Componente estilizado para layout centralizado vertical
const CenteredLayout = styled.div`
  display: grid;
  row-gap: 0.25rem;
  place-items: center;
  text-align: center;
`;

// Componente estilizado para layout de duas colunas
const DoubleColumnsLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 0.5rem;
`;

// Componente estilizado para os valores nas colunas
const ColumnValueLayout = styled.div`
  display: grid;
  row-gap: 0.25rem;
  place-items: center;
  text-align: center;
`;

// Componente estilizado para descrições com peso normal
const NormalWeightDescription = styled.span`
  font-weight: normal;
`;

/**
 * @typedef {Object} MonitoringStatCardProps
 * @property {string} title
 * @property {'vertical-centered-single' | 'vertical-centered-double'} layout
 */

/** @param {MonitoringStatCardProps} */
export const MonitoringStatCard = ({ layout, backgroundColor, ...props }) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  if (!layout?.length)
    throw new Error('o layout passado para o MonitoringStatCard não é válido');

  let children = null;

  if (layout === 'vertical-centered-single')
    children = <VerticalCenteredSingle {...props} />;

  if (layout === 'vertical-centered-double')
    children = <VerticalCenteredDouble {...props} />;

  if (children === null)
    throw new Error(
      `O layout passado para o MonitoringStatCard não é válido. Você informou o layout '${layout}', que não consta entre '${ALL_LAYOUTS.join(
        ' | '
      )}'`
    );

  return (
    <CardContainer
      borderRadius={systemConfiguration.border_radius}
      backgroundColor={backgroundColor}
      secondaryColor={systemConfiguration.secondary_color}
    >
      {children}
    </CardContainer>
  );
};

/** @param {MonitoringStatCardProps & { value: string }} */
const VerticalCenteredSingle = ({ title, value }) => {
  return (
    <CenteredLayout>
      <span>{title}</span>
      <span style={{ fontSize: '2rem' }}>{value}</span>
    </CenteredLayout>
  );
};

/** @param {MonitoringStatCardProps & { leftValue: {value: string, description: string},rightValue: {value: string, description: string} }} */
const VerticalCenteredDouble = ({ title, leftValue, rightValue }) => {
  return (
    <CenteredLayout>
      <span>{title}</span>
      <DoubleColumnsLayout>
        <ColumnValueLayout>
          <span style={{ fontSize: '2rem' }}>{leftValue.value}</span>
          <NormalWeightDescription>
            {leftValue.description}
          </NormalWeightDescription>
        </ColumnValueLayout>
        <ColumnValueLayout>
          <span style={{ fontSize: '2rem' }}>{rightValue.value}</span>
          <NormalWeightDescription>
            {rightValue.description}
          </NormalWeightDescription>
        </ColumnValueLayout>
      </DoubleColumnsLayout>
    </CenteredLayout>
  );
};
